import React, { useEffect } from 'react';
import List from '@mui/material/List';
import {
    Box,
    Typography,
} from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import { Downgraded, useState } from '@hookstate/core';

const listStyle = {
    width: '100%',
    height: '50vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
        width: '5px',
        height: '5px',
        backgroundColor: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#c1c1c1',
    }
}
const UserCheckList = (props) => {
    const selected = useState([]);
    const handleToggle = (value) => {
        const newSelected = selected.attach(Downgraded).get();
        const currentIndex = newSelected.indexOf(value.userID);
        if (currentIndex === -1) {
            newSelected.push(value.userID);
        } else {
            newSelected.splice(currentIndex, 1);
        }

        if (newSelected) {
            props.checkUsers(newSelected);
        }
        selected.set(newSelected);
    };

    useEffect(() => {
        if (props.selectedUsers) {
            selected.set(props.selectedUsers)
        }
    }, [props])
    return (
        <List sx={listStyle}>
            {props.data &&
                props.data.map((item, index) => {
                    const labelId = `checkbox-list-label-${index}`;
                    // console.log('selected : ', selected.get());
                    // console.log('check : ', selected.get().indexOf(item.userID));
                    return (
                        <Box
                        sx={{
                         display:'flex',
                         flexDirection: 'column',
                        }}
                        >
                        <ListItem key={`user_${index}`} disablePadding disabled={props.disabledBox ? true : false}>
                            <ListItemButton
                                role={undefined}
                                onClick={() => !props.disabledBox ? handleToggle(item) : null}
                                dense>
                                <Box
                                sx={{
                                    display:'flex',
                                    width:'100%',
                                }}
                                >
                                <Box
                                sx={{
                                    display:'flex',
                                    flexDirection:'row',
                                    alignItems:'center',
                                    justifyContent:'flex-start',
                                    width:'64%',
                                }}
                                >
                                {props.sentInvitationList != undefined ? null :
                                    <ListItemIcon sx={{ height: '28px' }}>
                                        <Checkbox
                                            edge="start"
                                            checked={
                                                selected.get().indexOf(item.userID) !== -1
                                            }
                                            tabIndex={-1}
                                            disableRipple
                                            inputProps={{
                                                'aria-labelledby': labelId,
                                            }}
                                        />
                                    </ListItemIcon>
                                }
                            <Box
                            sx={{
                               display:'flex',
                               flexDirection:'row',
                               alignItems:'baseline',
                               width:'100%' 
                            }}
                            >
                                <Box
                                sx={{
                                    width:'60%', 
                                }}
                                >
                                <Box>
                                <ListItemText sx={props.showRole ? {textAlign: 'left', flex: '0.3' } : {textAlign: 'left', flex: '1' }}

                                    primary={
                                        <Typography variant='span' sx={{alignItems: 'center', display: 'flex',pb:'8px'}}>
                                            {item.name}&nbsp;
                                            {/* {props.showRole && props.showRole?null: <a
                                                href={`javascript: void(0)`} style={{textDecoration: 'none', fontSize: '12px'}}>
                                                {' - '}
                                                {item.email}{' '}
                                            </a>} */}
                                            
                                        </Typography>                                        
                                    }
                                />
                                </Box>
                                <Box
                                sx={{
                                    mt:'-10px'
                                }}
                                >
                                {props.showRole && props.showRole?
                                     <a
                                     href={`javascript: void(0)`} style={{textDecoration: 'none', fontSize: '12px'}}>
                                     {item.email}
                                     </a> :null                                       
                                 }
                                </Box>
                                </Box>
                                <Box
                                   sx={{
                                    width:'40%'
                                }}
                                >
                                {props.showRole && <ListItemText sx={{ textAlign: 'left', flex: '0.3' }}

                                    primary={item.roleName}
                                />}
                                </Box>
                        </Box>
                            </Box>
                                <Box
                                sx={{
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    justifyContent:'center',
                                    width:'36%',
                                }}
                                >
                                    
                                {props.showRole && <ListItemText sx={{ textAlign: 'left', flex: '0.3',fontSize:'10px' }}
                                >
                                    {item.userTags && item.userTags !='' && item.userTags !== null && item.userTags.split(', ').map((tag, i) => {
                                        return <Chip key={i} sx={{ mr: '4px', mb: '2px',fontSize:'10px' }} label={tag} />
                                    })}
                                </ListItemText>}
                                </Box>
                                </Box>
                                
                            </ListItemButton>
                        </ListItem>
                         </Box>
                    );
                })}
        </List>
    );
};

export default UserCheckList;
